import {computed, observable, observer, React, useAsObservableSource, useLocalStore} from '@api'
import {CatalogItemShapeStore, TldrawApp, useTldrawApp} from '@modules/whiteboard'
import {SelectedShapesTitleUtil} from './SelectedShapesTitle'
import * as css from './SelectedShapesTitleComponent.css'
import {HTMLContainer, TLComponentProps} from '@tldraw/core'
import {SelectedShapesTitleShape} from './'
import {ShapeComponentStore} from '@modules/whiteboard/shapes/ShapeComponentStore'

interface MyProps extends TLComponentProps<SelectedShapesTitleShape> {

}

/// region Store

export class SelectedShapesTitleComponentStore extends ShapeComponentStore<SelectedShapesTitleShape, SelectedShapesTitleUtil> {
  constructor(public props: MyProps & { app: TldrawApp }) {
    super(props)
  }

  @observable maxToShow = 3

  @computed get titledShapes() {
    const {app: {selectedShapesByType, shapeComponentStores}} = this,
      cards = selectedShapesByType['builderCard'] ?? []

    return cards.map(c => shapeComponentStores[c.id] as CatalogItemShapeStore).filter(_.identity)
  }

  @computed get title() {
    const {app: {selectedShapesByType}, titledShapes, maxToShow} = this
    if (_.isEmpty(titledShapes)) return ''

    let r = _.take(titledShapes, maxToShow).map(s => s.title).join(', '),
      more = titledShapes.length - maxToShow

    if (more > 0) {
      r += `, and ${more.toLocaleString()} more`
    }

    return r
  }
}

export const SelectedShapesTitleComponent = observer<TLComponentProps<SelectedShapesTitleShape>, HTMLDivElement>(function SelectedShapesTitleComponent(props, ref) {
  const app = useTldrawApp(),
    obsProps = useAsObservableSource({...props, app}),
    store = useLocalStore(() => new SelectedShapesTitleComponentStore(obsProps)),
    {title} = store

  return (
      <HTMLContainer ref={ref} // {...events} // don't allow interactions
      >
        <div className={css.root}
        >
          <label>{title}</label>
        </div>
      </HTMLContainer>
  )
}, {forwardRef: true})



// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/selectedShapesCombinedTitle/SelectedShapesTitleComponent.tsx